import React, { useState } from 'react';
import { IApp } from '../Interfaces/IApp';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Typography,
  useTheme,
} from '@mui/material';
import { IAppSetting } from '../Interfaces/IAppSetting';
import { ConfigAppArnoTop } from './AppConfigurations/ConfigAppArnoTop';

interface IProps {
  app: IApp;
  appSettingArray: IAppSetting[];
  onSave: () => void;
}

export const ActivExtensionCard: React.FC<IProps> = ({
  app,
  appSettingArray,
  onSave,
}) => {
  const theme = useTheme();
  const ownSettings = appSettingArray.filter(sett => sett.idApp === app.idApp);

  const [isOpenConfig, setIsOpenConfig] = useState(false);

  const handleOpen = () => {
    setIsOpenConfig(true);
  };
  const handleClose = () => {
    setIsOpenConfig(false);
  };

  return (
    <>
      {isOpenConfig && (
        <Dialog open onClose={handleClose} maxWidth='md' fullWidth>
          <DialogContent>
            {app.system_key === 'arno_top' ? (
              <ConfigAppArnoTop
                app={app}
                appSettingArray={appSettingArray}
                onClose={handleClose}
                onSave={onSave}
              />
            ) : (
              <>Fehler!</>
            )}
          </DialogContent>
        </Dialog>
      )}

      <Box
        sx={{
          backgroundColor: theme.palette.grey[100],
          p: 3,
          borderRadius: 4,
          border: `1px solid ${theme.palette.grey[200]}`,
          mb: 2,
        }}
      >
        <Box>
          <Box>
            <Typography component='h3'>{app.App}</Typography>
            <Typography variant='caption'>Aktiv</Typography>
          </Box>

          {ownSettings.length === 0 ? (
            <Typography
              sx={{ float: 'right', mt: -4, color: theme.palette.grey[400] }}
            >
              Keine Konfiguration möglich
            </Typography>
          ) : (
            <Button
              variant='contained'
              sx={{ float: 'right', mt: -5 }}
              onClick={handleOpen}
            >
              Konfigurieren
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};
